export default "__VITE_ASSET__ChFdJBnl__"